import React from 'react';
// import shallowCompare from 'react-addons-shallow-compare';
import Select from 'react-select';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import classnames from 'classnames';

import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';

import toUTCtime from '../../../../helper/UTCtime.js';
import { toast } from 'react-toastify';

import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'

export default class ModalWorkRegister extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggled  : false,
      overflow : 'hidden',
      request            : this.props.data.alias,
      description        : this.props.data.description,
      repeatPeriod       : '0',
      repeatType         : 'days',

      scheduledStart     : '',
      scheduledEnd       : '',
      nextScheduled      : '',

      scheduledStart_UTC : '',
      scheduledEnd_UTC   : '',
      nextScheduled_UTC  : null,

      isReminder         : 'No',
      isRepeat           : 'No',

      minDate             : moment(),
      minDateScheduledEnd : moment(),
      minDateNextSchedule : moment().add(1, 'days'),

      is_process       : false,
    }
    
    this.onRegister        = this.onRegister.bind(this)
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this)
    this.onRegisterFailed  = this.onRegisterFailed.bind(this)
  }

  handleCheckboxChange(event) {
    if(event.target.name === 'isReminder') {
      this.setState({isReminder: event.target.checked ? 'Yes' : 'No'})
    } else {
      this.setState({
        toggled: event.target.checked,
        isRepeat: event.target.checked ? 'Yes' : 'No'
      })
    }
  }

  onOpen() {
    this.setState({overflow: 'visible'})
  }
  onClose() {
    this.setState({overflow: 'hidden'})
  }

  clear() {
    this.setState({
      repeatPeriod         : '0',
      repeatType           : 'days',
      scheduledStart       : '',
      scheduledEnd         : '',
      nextScheduled        : '',
      scheduledStart_UTC   : '',
      scheduledEnd_UTC     : '',
      nextScheduled_UTC    : null,
      isReminder           : 'No',
      isRepeat             : 'No',
      minDate              : moment(),
      minDateScheduledEnd  : '',
      minDateNextSchedule : '',
    })
  }

  onChangeScheduledStart(date) {
    let tmpDate = new Date(date._d);
    
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);

    let endD = moment(date).add(1, 'days')
    let nextS = this.state.nextScheduled
    if (nextS){
      if (nextS < endD){
        nextS = moment(endD).add(1, 'days')
      }
    }

    this.setState({
      scheduledStart      : date,
      scheduledEnd        : moment(date).add(1, 'days'),
      minDateScheduledEnd : date,
      nextScheduled       : nextS,
      minDateNextSchedule : moment(date).add(2, 'days'),
      scheduledStart_UTC  : toUTCtime(tmpDate),
      scheduledEnd_UTC    : toUTCtime(tmpDate),
    })
  }

  onChangeScheduledEnd(date) {
    let tmpDate = new Date(date._d);
    
    tmpDate.setHours(23);
    tmpDate.setMinutes(59);
    tmpDate.setSeconds(59);

    let nextS = this.state.nextScheduled
    if (nextS){
      if (nextS <= date){
        nextS = moment(date).add(1, 'days')
      }
    }

    this.setState({
      scheduledEnd        : date,
      scheduledEnd_UTC    : toUTCtime(tmpDate),
      nextScheduled       : nextS,
      minDateNextSchedule : moment(date).add(1, 'days'),
    })
  }

  onChangeNextScheduled(date) {
    let tmpDate = new Date(date._d);
    
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);

    this.setState({
      nextScheduled     : date,
      nextScheduled_UTC : toUTCtime(tmpDate),
    })
  }

  /* Positive number only */
  positiveNumber(e) {
    if (e.target.validity.valid) {
      this.setState({repeatPeriod: e.target.value})
    }
  }

  onRegister() {
    if(!FormHelper.ValidateForm(this.state)) {
      return true
    }
    Presenter.RegisterRequest(
      RequestProperties.RegisterRequest(this, this.onRegisterSuccess, this.onRegisterFailed)
    )
    this.setState({is_process: true})
  }

  onRegisterSuccess(params, response) {
    toast.success('Add service work success')
    // this.props.updateRowAfterCreateWork(response.data)
    this.props.loadData()
    this.props.closeModalWork()
    this.clear();
    this.setState({is_process: false}) 
  }

  onRegisterFailed(error) {
    this.setState({is_process: false}) 
    console.log(error);
    try {
      for(let key in error.response.data) {
        if(error.response.data.hasOwnProperty(key)) {
          toast.error("Error on " + key + " : " + JSON.stringify(error.response.data[key]))
        }
      }
    }
    catch(error) {
      console.error(error);
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return shallowCompare(this, nextProps, nextState);
  // }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data.alias !== '') {
      this.setState({
        request : nextProps.data.alias,
        description: nextProps.data.description
      })
    }
  }

  render() {
    const props = this.props;
    const {is_process}  = this.state

    return (
      <Modal isOpen={props.modal} toggle={()=>props.closeModalWork()}  className={props.className}>
        <ModalHeader toggle={()=>props.closeModalWork()}>Work Register</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label>Asset / Tools</label>
              <input type="text"
                className="form-control"
                name="assetName"
                defaultValue={props.data.assetName}
                disabled
              />
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea 
                className="form-control"
                name="description"
                cols="30" 
                rows="2"
                value={this.state.description}
                onChange={(e)=>{this.setState({description: e.target.value})}}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Scheduled Start</label>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDate}
                selected={this.state.scheduledStart}
                onChange={(e)=> this.onChangeScheduledStart(e) }
                readOnly
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Scheduled End</label>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDateScheduledEnd}
                selected={this.state.scheduledEnd}
                onChange={(e)=> this.onChangeScheduledEnd(e)}
                readOnly
              />
            </div>
            <div className="form-group col-md-12">
              <label className="optional">Next Scheduled </label>
              <span
                className="clear-date no-select" 
                onClick={()=>{this.setState({nextScheduled_UTC: null, nextScheduled: ''})}}>clear</span>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDateNextSchedule}
                selected={this.state.nextScheduled}
                onChange={(e)=> this.onChangeNextScheduled(e)}
                readOnly
              />
            </div>
            <div className="isRepeatLabel">
              <div style={{'flexBasis': '54%'}}>              
                <label className="spaceRRR mb0">is Reminder <small>(default : No)</small></label>
                <label className="switch switch-sm switch-text switch-primary mb0">
                  <input 
                    onChange={(event)=>this.handleCheckboxChange(event)}
                    name='isReminder'
                    type="checkbox" 
                    className="switch-input" 
                  />
                  <span className="switch-label" data-on="Yes" data-off="No"></span>
                  <span className="switch-handle"></span>
                </label>
              </div>
              <div>
                <label className="spaceRRR mb0">is Repeating?</label>
                <label className="switch switch-sm switch-text switch-primary mb0">
                  <input 
                    onChange={(event)=>this.handleCheckboxChange(event)} 
                    name='isRepeat'
                    type="checkbox" 
                    className="switch-input"
                    checked={this.state.toggled}
                  />
                  <span className="switch-label" data-on="On" data-off="Off"></span>
                  <span className="switch-handle"></span>
                </label>
              </div>
            </div>
            <div className={classnames('isRepeatBox', {open: this.state.toggled})} style={{'overflow': this.state.overflow}}>
              <div className="row">
                <div className="form-group col-sm-6" style={{'paddingTop': '13px'}}>
                  <label className="required">Repeat Period</label>
                  <input type="number"
                    className="form-control"
                    onChange={(e)=>this.positiveNumber(e)}
                    min="0"
                    pattern="^[0-9]"
                    name="repeartPeriod"
                    value={this.state.repeatPeriod} 
                  />
                </div>
                <div className="form-group col-sm-6" style={{'paddingTop': '13px'}}>
                  <label>Repeat Type&nbsp;<small>(default : Days)</small></label>
                  <Select
                    name="service "
                    placeholder="Type Repeat Type"
                    onOpen={()=>this.onOpen()}
                    onClose={()=>this.onClose()}
                    clearable={false}
                    value={this.state.repeatType}
                    options={[
                      { value: 'days', label: 'Days' },
                      { value: 'weeks', label: 'Weeks' },
                      { value: 'months', label: 'Months' },
                      { value: 'years', label: 'Years' },
                    ]}
                    onChange={(val) => this.setState({repeatType: val.value})}
                  />
                </div>
                </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={()=>props.closeModalWork()}>cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.onRegister()}>Register</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/request/helper/component/Modal/ModalWorkRegister.js